// Wrap an existing element with some content
/**
 * Function to wrap an existing element
 * @param {Node} el The existing element to wrap
 * @param {Node} wrapper The element to wrap
 */
export function wrap (el, wrapper) {
  wrapChildren(el, wrapper)
  el.appendChild(wrapper)
}

/**
 * Function to wrap the children of an element
 * @param {Node} el The element containing existing children to wrap
 * @param {Node} wrapper The element to wrap the children
 */
export function wrapChildren (el, wrapper) {
  while (el.hasChildNodes()) {
    wrapper.appendChild(el.removeChild(el.firstChild))
  }
}
